module.exports = __webpack_public_path__ + "static/img/partner-logo-9.0b92059e.png";